"use strict";
/**
 * Pure Domain Service for Manulife Universal Life & Unit-Linked Cash Flow Illustrations.
 * Part of @manulife/man-core DDD Domain Layer.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllustrationDomainService = void 0;
const actuarial_1 = require("./actuarial");
class IllustrationDomainService {
    /**
     * Generates annual cash flow projection table for PolicyAggregate using core Actuarial Engine.
     */
    static generateCashFlowTable(policy, assumedInterestRate = 0.04) {
        const totalPremium = policy.calculateTotalAnnualPremium().amount;
        const selectedRiderIds = policy.riders.map((r) => r.riderId);
        return (0, actuarial_1.calculateULCashflow)({
            age: policy.customer.age.years,
            gender: (policy.customer.gender === 'Nữ' ? 'Nữ' : 'Nam'),
            sumAssured: policy.sumAssured.amount,
            totalPremium,
            term: policy.term.years,
            selectedRiderIds,
            declaredInterestRate: assumedInterestRate,
            productId: policy.productCode,
        });
    }
    /**
     * Directly executes Actuarial Cashflow Engine calculation.
     */
    static calculateCashflow(input) {
        return (0, actuarial_1.calculateULCashflow)(input);
    }
}
exports.IllustrationDomainService = IllustrationDomainService;
